import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Divider,
    Grid,
    Typography,
    withStyles
} from '@material-ui/core';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import {
    getTemplateModeString,
    TemplateStopTemplateModeOption
} from "../../../services/enums/TemplateStopTemplateAlgorithmTypeHelper";
import {
    getModeOptionString,
} from "../../../services/enums/GoolgeMapsDistanceMatrixHelper";
import {DateService} from "../../../services/util/DateService";
import styles from './styles';

function TemplateMetaDataDialog(props) {
    const {
        classes,
        template,
        open,
        onClose,
        t,
    } = props;

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogContent>
                <Grid item xs={12}>
                    <Typography
                        variant="subtitle1"
                        className={classes.header}
                    >
                        {t('templateMetaData')}
                    </Typography>
                </Grid>
                <Grid container spacing={2}>
                {/*template mode*/}
                    <Grid item xs={6}>
                        <Typography variant="subtitle2">
                            {t('templateMode')}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography>
                            {t(getTemplateModeString(template.templateMode))}
                        </Typography>
                    </Grid>

                    {/*travel mode*/}
                    <Grid item xs={6}>
                        <Typography variant="subtitle2">
                            {t('travelMode')}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography>
                            {t(getModeOptionString(template.travelMode))}
                        </Typography>
                    </Grid>

                    {/*departure time*/}
                    <Grid item xs={6}>
                        <Typography variant="subtitle2">
                            {t('departureTime')}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography>
                            {DateService.displayDateTime(template.departureTime)}
                        </Typography>
                    </Grid>

                    {/*last updated*/}
                    <Grid item xs={6}>
                        <Typography variant="subtitle2">
                            {t('lastUpdated')}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography>
                            {DateService.displayDateTime(template.lastUpdated)}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider />
                    </Grid>

                    {/*only if template is automatic */}
                    {template.templateMode !== TemplateStopTemplateModeOption.Manual && template.templateMetadata && (
                        <>
                            <Grid item xs={12}>
                                <Typography
                                    variant="subtitle1"
                                    className={classes.header}
                                >
                                    {t('algorithmParameter')}
                                </Typography>
                            </Grid>

                            {/*vehicle capacity*/}
                            <Grid item xs={6}>
                                <Typography variant="subtitle2">{t('vehicleTemplateCapacity')}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>{template.templateMetadata.vehicleCapacity || '-'}</Typography>
                            </Grid>

                            {/*use stop capacities from DB*/}
                            <Grid item xs={6}>
                                <Typography variant="subtitle2">{t('useCapacitiesFromDB')}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>{template.templateMetadata.useStopCapacitiesFromDb ? t('yes'): t('no')}</Typography>
                            </Grid>


                            {/*fixed shop and chest capacities*/}
                            {!template.templateMetadata.useStopCapacitiesFromDb &&
                                <>
                                    <Grid item xs={6}>
                                        <Typography variant="subtitle2">{t('chestCapacity')}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography>{template.templateMetadata.chestCapacityDefaultValue || '-'}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="subtitle2">{t('shopCapacity')}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography>{template.templateMetadata.shopCapacityDefaultValue || '-'}</Typography>
                                    </Grid>
                                </>
                            }
                            
                            {/*num tours planned*/}
                            <Grid item xs={6}>
                                <Typography variant="subtitle2">{t('tourCount')}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>{template.templateMetadata.numToursToPlan}</Typography>
                            </Grid>
                            
                            {/*time limit*/}
                            <Grid item xs={6}>
                                <Typography variant="subtitle2">{t('timeLimit')}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>{template.templateMetadata.timeLimit || '-'}</Typography>
                            </Grid>
                            
                            {/*use relations*/}
                            <Grid item xs={6}>
                                <Typography variant="subtitle2">{t('useRelations')}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>{template.templateMetadata.useRelations ? t('yes'): t('no')}</Typography>
                            </Grid>

                            {/*use manhattan distance*/}
                            <Grid item xs={6}>
                                <Typography variant="subtitle2">{t('useManhattanDistance')}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>{template.templateMetadata.useManhattanDistance ? t('yes'): t('no')}</Typography>
                            </Grid>


                            {/*manhattan speed*/}
                            {template.templateMetadata.useManhattanDistance &&
                                <>
                                    <Grid item xs={6}>
                                        <Typography variant="subtitle2">{t('vehicleAverageSpeedKmh')}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography>{template.templateMetadata.manhattanDistanceSpeed || '-'}</Typography>
                                    </Grid>
                                </>
                            }
                        </>
                    )}
                </Grid>

            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="default">
                    {t('back')}
                </Button>
            </DialogActions>
        </Dialog>
    )
        ;
}

TemplateMetaDataDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    template: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(styles)(TemplateMetaDataDialog));